<template>
    <div class="home">
        <div class="content-overlay"></div>

        <section v-if="page != null && !page.hideTitle" class="board container-fluid">
            <div class="page-header margin-top-md mobile-margin-top-0">{{page.name}}</div>
        </section>

        <section class="board container-fluid">
            <mb-loading v-if="isLoading"></mb-loading>
            <div v-else-if="pageErrors.length > 0">
                <h3>Attenzione</h3>
                <p v-for="(error, key) in pageErrors" :key="key">
                    {{error}}
                </p>

                <div class="row">
                    <div class="col-12 col-sm-4 offset-sm-4">
                        <button @click="goToHome()" id="my-submit" class="go-to-cart-button button red-button button-full" type="button">Torna alla home</button>
                    </div>
                </div>
            </div>
            <div v-else-if="otpResponse" class="confermaRegistrazione">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="fist-page-text" v-html="page.lastPageText"></div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12" v-for="(emailText, key) in otpResponse.productActivation" :key="key">
                        <div class="prodotto-attivazione" v-html="emailText"></div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-sm-4 offset-sm-4">
                        <button @click="onClickCta()" id="my-submit" class="go-to-cart-button button red-button button-full" type="button">
                            <template v-if="page.confirmPageCtaText">{{ page.lastPageCtaText }}</template>
                            <template v-else>Torna alla home</template>
                        </button>
                    </div>
                </div>
            </div>
        </section>
        <MbScriptField :value="page.lastPageScript"></MbScriptField>
    </div>
</template>

<script>
import MediaLibraryAPI from "@/service/MediaLibraryAPI"
import MbLoading from "@/components/newsletter_form/MbLoading.vue"
import MbPageService from './MbPageService'
import MbScriptField from "@/components/newsletter_form/MbScriptField"

export default {
    components: {
        MbLoading,
        MbScriptField
    },
    data(){
        return {
            otp: "",
            permalink: '',
            isLoading: true,
            page: {},
            pageErrors: [],
            otpResponse: {}
        }
    },
    created() {
        this.loadPage()
    },
    methods: {
        loadPage(){
            this.isLoading = true
            
            this.permalink = this.$route.params.pagePermalink
            if (!this.permalink) {
                this.$router.push("/page-not-found")
                return
            }

            MediaLibraryAPI.getPage(this.permalink)
                .then(({ data }) => {
                    if (!data) {
                        this.pageErrors = ["Sistema non ragiungibile"]
                        this.isLoading = false
                        return
                    }

                    this.page = data.data
                    if (!this.page) {
                        this.pageErrors = ["Sistema non ragiungibile"]
                        this.isLoading = false
                        return
                    }

                    if (data.hasErrors) {
                        this.pageErrors = data.errors
                        this.isLoading = false
                        return
                    }

                    MbPageService.setPage(this.page)

                    if (this.$route.query.preview) {
                        this.otpResponse = {}
                        this.pageErrors = []
                        this.isLoading = false
                        return
                    }

                    this.confirmOTP()
                }).catch((errors) => {
                    this.pageErrors.push(errors)
                    this.isLoading = false
                })            
        },
        confirmOTP(){
            this.otp = this.$route.params.otp
            if (!this.otp || this.otp == ""){
                this.pageErrors = ["Link non valido"]
                this.isLoading = false
                return
            }

            MediaLibraryAPI.getNewsletterCheckOTP(this.otp)
                .then(({data}) => {
                    if (!data) {
                        this.pageErrors = ["Sistema non ragiungibile"]
                        this.isLoading = false
                        return
                    }

                    if (data.hasErrors) {
                        this.pageErrors = data.errors;
                        this.isLoading = false
                        return
                    }

                    if (this.page.permalink == 'newsletter') {
                        location.href = "https://www.erickson.it/it/thank-you-page/newsletter";
                        return
                    }

                    if (window.fbq){
                        let fbqData = {
                            "evento": this.page.name
                        }

                        let eventName = "ConfirmationPage"

                        if (this.page.permalink.indexOf("iscrizione-webinar") == 0) {
                            eventaname = "IscrizioneWebinar"
                        } else if (this.page.permalink.indexOf("corso-online") == 0 || this.page.permalink.indexOf("master") == 0) {
                            eventName = "FreeLessonConfirmationPage"
                        }

                        if (eventName) {
                            window.fbq('trackCustom', eventName, fbqData)
                        }
                    }

                    this.otpResponse = data.data
                    this.isLoading = false
                }).catch((error) => {
                    this.isLoading = false
                    this.pageErrors = [error]
                });
        },
        onClickCta() {
            if (this.page.confirmPageCtaUrl) {
                window.location.href = this.page.lastPageCtaUrl
                return
            }

            window.location.href = "https://www.erickson.it"
        }
    }
}
</script>

<style> 
    input {
        background-color: transparent;
        border: none;
    }

    .fist-page-text {
        padding-top: 20px;
        padding-bottom: 20px;
    }

    .prodotto-attivazione {
        border-left: 1px solid black;
        padding-left: 15px;
        margin-top: 15px;
        margin-bottom: 15px;
    }
    .prodotto-attivazione h4 {
        font-size: 1.1rem;
    }
    .prodotto-attivazione h3 {
        font-size: 1.4rem;
    }
</style>
